<template>
	<div id="MissinHall">
		<div class="pub_title">
			<div class="img_logo">
				<img src="../imges/lebiao/rwdt.png" alt="">
			</div>
			<div class="title_t">
				<div class="imhg_ti">
					<img src="../imges/lebiao/rwdt_font.png" alt="">
				</div>
				<div class="sm_t">
					<div style="float:left"><span>任务</span><span style="color:#D7230C;">大厅</span></div>
					<div class="sm_pub">你有需求，我能服务</div>
				</div>
			</div>
			<router-link tag="div" class="ckgd" to="/MissionHalldetails">
				查看更多&nbsp;>
			</router-link>
		</div>
		<div class="MissinHalls" style="box-shadow: 0 4px 24px rgba(0,0,0,.16);">
			<!-- 左 -->
			<div class="Missleft">
				<img src="../imges/rwdt_bg.png" style="width: 100%;height: 100%;" alt="">
				<div class="Hallleft">
					<div class="mytop">
						<img src="../imges/rwdt_nyxq.png"
							style="width: 60%;height: 60%;margin-left: 15px;margin-top: 12px;" alt="">
					</div>
					<div class="mycenter">
						你有需求
					</div>
					<div class="mytter">
						专业人士为您提供专业的服务
					</div>
					<div class="myfoot" @click="nyxq">
						发布需求
					</div>
				</div>
				<div class="Hallright">
					<div class="mytop">
						<img src="../imges/rwdt_wnfw.png"
							style="width: 60%;height: 60%;margin-left: 15px;margin-top: 12px;" alt="">
					</div>
					<div class="mycenter">
						我能服务
					</div>
					<div class="mytter">
						专业人士为您提供专业的服务
					</div>
					<div class="myfoot" @click="nyxq">
						寻找服务
					</div>
				</div>
			</div>
			<!-- 右 -->
			<div class="Missreght">
				<!-- 上 -->
				<div class="Misstop">
					<el-carousel :interval="4000" type="card" height="200px" indicator-position="none">
						<el-carousel-item v-for="(item,index) in xptjlist" :key="index">
							<img style="width: 100%;height: 100%;"  @click="gotorw(item)"
								:src="'https://admin.shipoe360.com/public/' + item.picurl" alt="">
							<div class="dift">{{item.title}}</div>
						</el-carousel-item>
					</el-carousel>
				</div>
				<!-- 下 -->
				<div class="Missfot">
					<div class="leftMiss">
						<ul>
							<router-link tag="li" :to="{ path:'/rwdtdetail',query:{id:item.id,title:item.title} }" v-for="(item,index) in leftzuo" :key="index">
								<span
									style="width: 200px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: inline-block;">
									{{item.title}}
								</span>
								<span style="color: #D7230C;float: right;">
									￥{{item.price}}
								</span>
							</router-link>
						</ul>
					</div>
					<div class="RightMiss">
						<ul>
							<router-link tag="li" :to="{ path:'/rwdtdetail',query:{id:item.id,title:item.title} }" v-for="(item,index) in rightyou" :key="index">
								<span
									style="width: 200px;white-space: nowrap;text-overflow: ellipsis;overflow: hidden;word-break: break-all;display: inline-block;">
									{{item.title}}
								</span>
								<span style="color: #D7230C;float: right;">
									￥{{item.price}}
								</span>
							</router-link>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	import http from "@/utils/http";
	export default {
		data() {
			return {
				xptjlist: '',
				leftzuo: '',
				rightyou: ''
			}
		},
		methods: {
			gotorw(val){
				console.log(1)
				this.$router.push({ path:'/rwdtdetail',query:{id:val.id,title:val.title} })
			},
			nyxq() {
			  const loginInfo = JSON.parse(window.sessionStorage.getItem('token') || null)
			  if (loginInfo == null) {
			    this.$router.push({
			      path: '/login'
			    })
			  } else {
			    this.$router.push({
			      path: '/user'
			    })
			
			  }
			},
		},
		async mounted() {
			let res = await http.post('api/picture/jobdt')
			this.xptjlist = res.data.data[0]
			let res1 = await http.post('api/picture/jobdt')
			this.leftzuo = res1.data.data[0]
			this.rightyou = res1.data.data[1]
		}
	}
</script>

<style>
	#MissinHall ul {
		padding-left: 10px;
	}

	#MissinHall ul>li {
		list-style: none;
		line-height: 22px;
		font-size: 14px;
	}

	.MissinHalls {
		width: 100%;
		height: 500px;
		margin-top: 20px;
		box-shadow: 10px 20px 10px -5px rgb(231, 231, 231);
		position: relative;
	}

	.Missleft {
		width: 470px;
		height: 330px;
		position: absolute;
		left: 30px;
		top: 90px;
		z-index: 2;
	}

	.Missreght {
		width: 800px;
		height: 450px;
		position: absolute;
		right: 20px;
		top: 25px;
		box-shadow: -5px 5px 5px 10px rgb(231, 231, 231);
	}

	.Missfot {
		margin-left: 125px;
		width: 650px;
		height: 200px;
	}

	.Misstop {
		margin-left: 125px;
		margin-top: 20px;
		width: 650px;
		height: 220px;
	}

	.dift {
		position: absolute;
		bottom: 0px;
		width: 100%;
		height: 20px;
		background: #c0c0c0;
		font-size: 14px;
		opacity: 0.7;
		text-align: center;
	}

	.leftMiss {
		width: 310px;
		height: 200px;
		float: left;
	}

	.leftMiss>ul>li:hover {
		cursor: pointer;
	}

	.RightMiss>ul>li:hover {
		cursor: pointer;
	}

	.RightMiss {
		width: 310px;
		height: 200px;
		float: left;
		margin-left: 30px;
	}

	.Hallleft {
		width: 150px;
		height: 200px;
		background-color: #FFF;
		position: absolute;
		top: 60px;
		left: 80px;
		border-radius: 5px;
	}

	.Hallright {
		width: 150px;
		height: 200px;
		background-color: #FFF;
		position: absolute;
		top: 60px;
		left: 250px;
		border-radius: 5px;
	}

	.mytop {
		width: 70px;
		height: 70px;
		margin-left: 40px;
		margin-top: 20px;
		border-radius: 50%;
		background-color: #fde9e5;
	}

	.mycenter {
		width: 100%;
		font-size: 18px;
		font-weight: 600;
		letter-spacing: 6px;
		margin-top: 10px;
		text-align: center;
	}

	.mytter {
		width: 100%;
		text-align: center;
		font-size: 12px;
		letter-spacing: 2px;
		transform: scale(0.7);
	}

	.myfoot {
		border: 1px solid #424242;
		width: 90px;
		text-align: center;
		font-size: 16px;
		margin: 0 auto;
		padding: 2px 6px;
		cursor: pointer;
		border-radius: 4px;
	}
	
	
</style>
